/* ByMeeru Buy Now reliability patch.
   Uses Shopify's locale-aware Ajax Cart API and retries transient
   422 "already sold out" responses before showing an error.
*/
(function () {
  'use strict';

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof root !== 'string' || !root) root = '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function addVariant(variantId, quantity, attempt) {
    attempt = attempt || 1;
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: String(variantId), quantity: Math.max(1, parseInt(quantity, 10) || 1) }] })
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (e) {}

        if (res.ok) return data;

        var message = data.description || data.message || 'Unable to add this product to the cart.';
        if (res.status === 422 && /already sold out|sold out/i.test(message) && attempt < 5) {
          return wait(500 * Math.pow(2, attempt - 1)).then(function () {
            return addVariant(variantId, quantity, attempt + 1);
          });
        }
        throw new Error(message);
      });
    });
  }

  function goCheckout() {
    window.location.href = rootUrl() + 'checkout';
  }

  function goCart() {
    window.location.href = rootUrl() + 'cart';
  }

  function setBusy(button) {
    if (!button) return function () {};
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    return function () {
      button.disabled = false;
      button.textContent = original;
    };
  }

  function run(button, form, checkout) {
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var restore = setBusy(button);

    addVariant(idInput.value, qtyInput ? qtyInput.value : 1)
      .then(function () {
        if (checkout) goCheckout();
        else goCart();
      })
      .catch(function (error) {
        restore();
        window.alert(error && error.message ? error.message : 'Unable to add this product to the cart.');
      });
  }

  /* Product-card Buy Now forms. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector('[data-bymeeru-buy-now]')) return;
    event.preventDefault();
    run(form.querySelector('[data-bymeeru-buy-now]'), form, true);
  }, true);

  /* Product-page Buy Now. Capture phase prevents the older theme.js click
     handler from submitting the form natively before this reliable path runs. */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-buy-now]') : null;
    if (!button) return;
    var form = button.closest('form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    run(button, form, true);
  }, true);
})();